module.exports = __webpack_public_path__ + "static/media/SMS-small.aa44e781.svg";